import { Flex, Tooltip } from "@chakra-ui/react";
import React from "react";

export interface StatTooltipProps {
  label: string;
}

export const StatTooltip: React.FC<
  React.PropsWithChildren<StatTooltipProps>
> = ({ label, children }) => (
  <Flex
    flex={1}
    sx={{
      "& .chakra-stat": {
        flexGrow: 0,
      },
    }}
  >
    <Tooltip hasArrow={true} label={label}>
      {children}
    </Tooltip>
  </Flex>
);
